import React, { useState } from 'react';
import { COLORS } from '../../../../utils/constants';
import { adminAPI } from '../../../../services/api';
import { ModalWrapper, FormInput } from './ModalComponents';

const CreateClientModal = ({ managers, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    phone: '',
    assigned_to: '',
  });

  const handleSubmit = async () => {
    if (!formData.email || !formData.password) {
      setError('Email и пароль обязательны');
      return;
    }

    if (formData.password.length < 6) {
      setError('Пароль должен быть не менее 6 символов');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await adminAPI.createUser({
        email: formData.email.toLowerCase().trim(),
        password: formData.password,
        name: formData.name || undefined,
        phone: formData.phone || undefined,
        assigned_to: formData.assigned_to || undefined,
        role: 'user',
      });
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка при создании клиента');
    } finally {
      setLoading(false);
    }
  };

  const generatePassword = () => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
    let password = '';
    for (let i = 0; i < 10; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setFormData({ ...formData, password });
  };

  return (
    <ModalWrapper title="Создать клиента" onClose={onClose}>
      {error && (
        <div style={{
          padding: '12px',
          backgroundColor: `${COLORS.danger}20`,
          border: `1px solid ${COLORS.danger}`,
          borderRadius: '8px',
          color: COLORS.danger,
          fontSize: '14px',
          marginBottom: '16px'
        }}>
          {error}
        </div>
      )}

      <FormInput
        label="Email *"
        type="email"
        value={formData.email}
        onChange={(val) => setFormData({ ...formData, email: val })}
        placeholder="client@example.com"
      />

      <div style={{ marginBottom: '12px' }}>
        <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>
          Пароль *
        </label>
        <div style={{ display: 'flex', gap: '8px' }}>
          <input
            type="text"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            placeholder="Минимум 6 символов"
            style={{
              flex: 1,
              padding: '12px',
              backgroundColor: COLORS.background,
              border: `1px solid ${COLORS.border}`,
              borderRadius: '8px',
              color: COLORS.text,
              fontSize: '14px'
            }}
          />
          <button
            type="button"
            onClick={generatePassword}
            style={{
              padding: '12px 16px',
              backgroundColor: COLORS.background,
              border: `1px solid ${COLORS.border}`,
              borderRadius: '8px',
              color: COLORS.primary,
              fontSize: '13px',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            Сгенерировать
          </button>
        </div>
      </div>

      <FormInput
        label="Имя"
        value={formData.name}
        onChange={(val) => setFormData({ ...formData, name: val })}
        placeholder="Имя клиента"
      />

      <FormInput
        label="Телефон"
        type="tel"
        value={formData.phone}
        onChange={(val) => setFormData({ ...formData, phone: val })}
        placeholder="+7 999 123 45 67"
      />

      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>
          Назначить менеджеру
        </label>
        <select
          value={formData.assigned_to}
          onChange={(e) => setFormData({ ...formData, assigned_to: e.target.value })}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: COLORS.background,
            border: `1px solid ${COLORS.border}`,
            borderRadius: '8px',
            color: COLORS.text,
            fontSize: '14px'
          }}
        >
          <option value="">Не назначен</option>
          {managers.map(m => (
            <option key={m.id} value={m.id}>{m.name || m.email}</option>
          ))}
        </select>
      </div>

      <button
        onClick={handleSubmit}
        disabled={loading}
        style={{
          width: '100%',
          padding: '14px',
          backgroundColor: loading ? COLORS.border : COLORS.primary,
          border: 'none',
          borderRadius: '8px',
          color: loading ? COLORS.textSecondary : '#000',
          fontSize: '15px',
          fontWeight: '600',
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'Создание...' : 'Создать клиента'}
      </button>
    </ModalWrapper>
  );
};

export default CreateClientModal;
